import { BaseService } from '@core/base/service/base-service'
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: 'G-SE60ET0QM7',
}

export const GtmService = new (class GTMService extends BaseService {
    constructor() {
        super('gtm.service')
    }

    get isEnabled() {
        return (
            !import.meta.env.DEV && this.envVars.REACT_APP_ENV === 'production'
        )
    }

    init() {
        if (this.isEnabled) {
            TagManager.initialize(tagManagerArgs)
        }
    }
})()
